import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchEPoliciesMrise } from "./ethicspolicyAPI";

export interface EPolicyState {
  epoliciesMrise: Array<any>;
  poshPolicies: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: EPolicyState = {
  epoliciesMrise: [],
  poshPolicies: [],
  status: "idle",
};

export const GetEthicsPoliciesMrise = createAsyncThunk(
  "epolicy/fetchEPoliciesMrise",
  async (type: string) => {
    const response = await fetchEPoliciesMrise(type);
    return response;
  }
);

export const epolicySlice = createSlice({
  name: "epolicy",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetEthicsPoliciesMrise.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetEthicsPoliciesMrise.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetEthicsPoliciesMrise.fulfilled, (state, action) => {
        state.status = "success";
        action.payload?.categories?.map((item: any) => {
          item?.policyCategorys?.map((policyCat: any) => {
            if (policyCat.title == "Ethics & Governance") {
              //return setPolicyListArr(policyCat.policies)
              state.epoliciesMrise = policyCat.policies;
              //console.log(policyCat.policies,"policyCat.policies")
            }
            if (policyCat.categoryId == "657bef1f471fc440e3d9b84f") {
              state.poshPolicies = policyCat.policies;
            }
          });
        });
      });
  },
});

export const {} = epolicySlice.actions;

export const selectEPoliciesMrise = (state: RootState) => {
  return state.epolicyMrise.epoliciesMrise;
};
export const selectPOSHPolicies = (state: RootState) => {
  return state.epolicyMrise.poshPolicies;
};

export default epolicySlice.reducer;
